export default { sha: '407adbd8bbf1057f547ffbde918c377a8d8b5cc3', buildNumber: 'undefined' }
